import { useState, useEffect } from 'react';
import Navbar from './Navbar';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Temples.css';

var images = require.context('./images', true);

function Temples() {

    return (
        <div className="grid gap-0 row-gap-3">

            <div className="p-5">
                <Navbar />
            </div>


            <table className="table cardDeck">
                <tbody>
                    <tr>
                        <td>
                            <div>
                                <img
                                    src={images("./AboutUs.jpg")}
                                    alt="Dandenong"
                                    className="img-fluid"
                                />
                            </div>
                        </td>
                        <td>
                            <div>
                                <img
                                    src={images("./AboutUs.jpg")}
                                    alt="Cranbourne"
                                    className="img-fluid"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                                <p>Dandenong Temple<br />43 Hemmings Street, Dandenong</p><a href="https://maps.app.goo.gl/D3F5CwAfUVgbsJHG8" target="_blank" rel="noreferrer" className="link-opacity-100">Click to display map</a>
                            </div>
                        </td>
                        <td>
                            <div>
                                <p>Cranbourne Temple<br />1240 Western Port Highway, Cranbourne South</p><a href="https://maps.app.goo.gl/XkzhwseYESpSSuZb6" target="_blank" rel="noreferrer" className="link-opacity-100">Click to display map</a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>)
}
export default Temples;